import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import ChartCard from './ChartCard';

interface ConversionFunnelChartProps {
  data: Array<{
    stage: string;
    value: number;
  }>;
  title?: string;
  subtitle?: string;
}

const ConversionFunnelChart: React.FC<ConversionFunnelChartProps> = ({ 
  data, 
  title = 'Funil de Conversão',
  subtitle = 'Criado → Assinado → Ativo'
}) => {
  const colors = ['#3498db', '#f39c12', '#2ecc71'];
  
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      return (
        <div style={{
          background: 'rgba(44, 62, 80, 0.95)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          borderRadius: '8px',
          padding: '12px',
          color: '#fff',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
        }}>
          <p style={{ margin: '0 0 4px 0', fontWeight: 600 }}>{payload[0].payload.stage}</p>
          <p style={{ margin: 0, color: payload[0].color }}>
            {payload[0].value} contratos
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <ChartCard title={title} subtitle={subtitle}>
      <ResponsiveContainer width="100%" height={350}>
        <BarChart data={data} layout="vertical">
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255, 255, 255, 0.1)" />
          <XAxis type="number" stroke="rgba(255, 255, 255, 0.6)" />
          <YAxis dataKey="stage" type="category" stroke="rgba(255, 255, 255, 0.6)" width={120} />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Bar 
            dataKey="value" 
            fill={colors[0]}
            radius={[0, 8, 8, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
};

export default ConversionFunnelChart;

